import './styles/global.css';
import { createApp } from 'vue';
import App from './App.vue';
import { vReveal } from './directives/reveal';
import i18n from './i18n';
import router from './router';
createApp(App)
    .use(i18n)
    .use(router)
    .directive('reveal', vReveal)
    .mount('#app');
